import './Cart.scss';

import { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedNumber, FormattedMessage } from 'react-intl';

import {
  getCartItems,
  getCartTotal,
  getEnvironment
} from '../../selectors/appSelectors';
import { getCurrency } from '../../selectors/configSelectors';

import CartItem from '../../components/CartItem/CartItem';

import {
  updateCartItems,
  updateTotalAmount
} from '../../actions/sdkConfigActions';
import { HiButton } from '@hipay/design-system/components';

const Cart = (props) => {
  const [products, setProducts] = useState(props.cartItems);
  const [editable, setEditable] = useState(false);

  let handleCartItemsChange = (value, index) => {
    let updatedProduct = value;
    let currentProducts = products.map((product, idx) =>
      idx === index ? updatedProduct : product
    );
    setProducts([...currentProducts]);
    props.updateCartItems([...currentProducts], props.env);
    props.updateTotalAmount(
      String(
        currentProducts
          .reduce((total, item) => total + item.price * item.quantity, 0)
          .toFixed(2)
      )
    );
  };

  const handleButtonClick = () => {
    if (editable) {
      resetProductsPrice();
    }
    setEditable(!editable);
  };

  const resetProductsPrice = () => {
    let currentProducts = [...products];
    currentProducts = currentProducts.map((product, index) =>
      index === 0 ? { ...product, price: 0.4 } : { ...product, price: 0.3 }
    );
    setProducts([...currentProducts]);
    props.updateCartItems([...currentProducts], props.env);
  };

  return (
    <div className="Cart">
      <div className="cart-header">
        <h3>
          <FormattedMessage id={'order-summary'} />
        </h3>
      </div>

      <div className="cart-items">
        {products.map((product, index) => {
          return (
            <Fragment key={product.id}>
              <CartItem
                index={index}
                product={product}
                total={props.total}
                currency={props.currency}
                env={props.env}
                editable={editable}
                updateCartItems={handleCartItemsChange}
              />
              <div className="divider" />
            </Fragment>
          );
        })}
        <div className="amount-button-container">
          {props.env === 'production' && (
            <HiButton
              variant={'text'}
              size={'medium'}
              onClick={() => handleButtonClick()}
            >
              {editable ? (
                <FormattedMessage id={'cart-edit-complete'} />
              ) : (
                <FormattedMessage id={'cart-edit'} />
              )}
            </HiButton>
          )}
        </div>
      </div>

      <div className="total">
        <FormattedMessage className="total-text" id={'total'} />{' '}
        <FormattedNumber
          className="amount"
          value={props.total}
          // eslint-disable-next-line
          style="currency"
          currency={props.currency}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    currency: getCurrency(state),
    cartItems: getCartItems(state),
    total: getCartTotal(state),
    env: getEnvironment(state)
  };
};

export default connect(mapStateToProps, { updateCartItems, updateTotalAmount })(
  Cart
);
